import dayjs from 'dayjs';
import { z } from 'zod';

export enum GroupType {
    OUTBOUND = 'OUTBOUND',
    INBOUND = 'INBOUND',
    AD_HOC_BOX = 'AD_HOC-BOX'
}

export enum BoxType {
    NO_BOXES = 'NO_BOXES',
    NORMAL = 'NORMAL',
    IMPORT_ENABLED = 'IMPORT_ENABLED'
}

export enum ScanTypeStatus {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED'
}

const ScanTypeSchema = z.object({
    groupType: z.nativeEnum(GroupType),
    description: z.string(),
    name: z.string(),
    allowFailedChecks: z.boolean(),
    boxType: z.nativeEnum(BoxType),
    status: z.nativeEnum(ScanTypeStatus),
    active: z.boolean(),
    id: z.number(),
    isProtected: z.boolean(),
    createdByUsername: z.string(),
    locations: z.array(z.string()),
    createdTime: z
        .string()
        .refine((value) => dayjs(value).isValid())
        .transform(dayjs)
});

export type ScanType = z.infer<typeof ScanTypeSchema>;

export const ScanTypesSchema = z.object({
    page: z.number(),
    show: z.number(),
    count: z.number(),
    items: z.array(ScanTypeSchema)
});

export type PaginatedScanTypes = z.infer<typeof ScanTypesSchema>;

export const ScanTypeDetailsSchema = z
    .object({
        id: z.number(),
        name: z.string(),
        description: z.string(),
        groupType: z.nativeEnum(GroupType),
        active: z.boolean(),
        allowFailedChecks: z.boolean(),
        boxType: z.nativeEnum(BoxType),
        isProtected: z.boolean(),
        createdByUsername: z.string(),
        createdTime: z
            .string()
            .refine((value) => dayjs(value).isValid())
            .transform(dayjs),
        status: z.nativeEnum(ScanTypeStatus),
        locations: z.array(z.string())
    })
    .brand('ScanTypeDetails');

export type ScanTypeDetails = z.infer<typeof ScanTypeDetailsSchema>;
